import { render } from "./Waki Pharma.vue?vue&type=template&id=01c08812&scoped=true"
const script = {}

import "./Waki Pharma.vue?vue&type=style&index=0&id=01c08812&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01c08812"

export default script